import { useEffect, useState } from 'react'

/**
 * Returns the current window inner width, debounced by `debounceMs`.
 * Subsequent resize events within the debounce window coalesce into a
 * single update. SSR-safe (returns 0 on the server).
 */
export function useViewportWidth(debounceMs = 100): number {
  const [width, setWidth] = useState<number>(() =>
    typeof window === 'undefined' ? 0 : window.innerWidth,
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    let timer: ReturnType<typeof setTimeout> | null = null
    function onResize() {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        setWidth(window.innerWidth)
      }, debounceMs)
    }
    window.addEventListener('resize', onResize)
    return () => {
      if (timer) clearTimeout(timer)
      window.removeEventListener('resize', onResize)
    }
  }, [debounceMs])

  return width
}
